import React from "react"
import Template from "../../components/Template"
import img1 from "../../images/soundalerts/soundicon.png"
import img2 from "../../images/soundalerts/soindicon2.png"
import img3 from "../../images/soundalerts/changesound.png"
import Translations from "../../../components/Translations"
import style from "../../../../style"

function SoundAlerts() {
    const Content = () => {
        return (
            <div>
                <Translations category={"docsSoundAlerts"} id={1}/>
                <img src={img2} alt='/' className={`${style.borderImg} my-5`}/>
                <Translations category={"docsSoundAlerts"} id={2}/>
                <img src={img1} alt='/' className={`${style.borderImg} my-5`}/>
                <div className={"mt-5 mb-5"}>
                    <Translations category={"docsSoundAlerts"} id={3}/>
                </div>
                <img src={img3} alt='/' className={`${style.borderImg} my-5`}/>
            </div>
        )
    }
    const config = {
        title: <Translations category={"docs"} id={19}/>,
        previousLink: '/docs/text-alerts',
        previousTitle: <Translations category={"docs"} id={18}/>,
        nextLink: '/docs/relative-strength-index',
        nextTitle: <Translations category={"docs"} id={21}/>,
        content: Content(),
    }

    return (
        <Template config={config}/>
    )
}

export default SoundAlerts